import React from "react";

export const SEV_COLOR = {
  Critical: "#A5300F", High: "#D55816", Medium: "#E39629", Low: "#7F5F52", Info: "#9AA0A6",
};
export const STATUS_COLOR = {
  Open: "#A5300F", "In Progress": "#E39629", "Risk Accepted": "#7F5F52",
  "False Positive": "#9AA0A6", Remediated: "#2E7D32",
};

export function Card({ children, className = "", ...rest }) {
  return (
    <div className={`bg-white border border-[#ECE6DD] rounded-lg ${className}`} {...rest}>
      {children}
    </div>
  );
}

export function SectionTitle({ children, className = "" }) {
  return <h2 className={`section-title text-lg ${className}`}>{children}</h2>;
}

export function SeverityChip({ severity, small }) {
  const c = SEV_COLOR[severity] || "#9AA0A6";
  return (
    <span className={`inline-flex items-center gap-1 ${small ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-xs"} font-bold rounded`}
      style={{ color: c, background: `${c}14`, border: `1px solid ${c}33` }}>
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: c }} />
      {severity}
    </span>
  );
}

export function StatusBadge({ status }) {
  const c = STATUS_COLOR[status] || "#9AA0A6";
  return (
    <span className="inline-flex items-center px-2 py-0.5 text-xs font-semibold rounded"
      style={{ color: c, background: `${c}12`, border: `1px solid ${c}30` }}>{status}</span>
  );
}

export function Confidence({ label }) {
  const map = { Confirmed: "#2E7D32", Probable: "#E39629", Potential: "#9AA0A6" };
  const c = map[label] || "#9AA0A6";
  return <span className="text-xs font-semibold" style={{ color: c }}>{label}</span>;
}

export function SlaBadge({ status }) {
  const map = {
    "on track": ["#2E7D32", "On track"], "due soon": ["#E39629", "Due soon"],
    breached: ["#A5300F", "Breached"], closed: ["#9AA0A6", "Closed"],
  };
  const [c, label] = map[status] || ["#9AA0A6", status];
  return <span className="text-xs font-semibold" style={{ color: c }}>{label}</span>;
}

export function KevBadge() {
  return (
    <span className="inline-flex items-center px-1.5 py-0.5 text-[10px] font-bold rounded text-white" style={{ background: "#A5300F" }}>
      KEV
    </span>
  );
}

export function Stat({ label, value, sub, color }) {
  return (
    <Card className="p-5">
      <div className="text-[11px] uppercase tracking-wider text-[#8A8175] font-semibold">{label}</div>
      <div className="stat-numeral text-4xl mt-1" style={color ? { color } : undefined}>{value}</div>
      {sub && <div className="text-xs text-[#8A8175] mt-1">{sub}</div>}
    </Card>
  );
}

export function Spinner({ className = "" }) {
  return <span className={`inline-block w-4 h-4 border-2 border-[#A5300F] border-t-transparent rounded-full spin ${className}`} />;
}
